<template>
  <b-row>
    <b-col sm="12">
      <b-card header="Listado de zonas">
        <div class="table-responsive">
          <div class="form-group form-inline pull-left">
            <input v-model="search" type="search" class="form-control" placeholder="Buscar..."> &nbsp;
          </div>
          <div class="form-group form-inline pull-right">
            <button @click="newPlace" type="button" class="btn btn-primary">Nuevo</button>&nbsp;
          </div>
          <table class="table table-striped table-hover table-bordered">
            <thead>
            <tr>
              <th>Distrito</th>
              <th>Zona</th>
              <th>Acción</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(place,k) in paginated('filteredPlaces')" :key="k">
              <td>{{place.name}}</td>
              <td>{{place.zone ? place.zone.name : 'No especificado'}}</td>
              <td align="center"><a type="button"
                                    @click="editPlace(place,'Editar')"><span class="fa fa-edit fa-lg"></span></a></td>
            </tr>
            </tbody>
          </table>
          <paginate
            name="filteredPlaces"
            :list="filteredPlaces"
            class="paginate-list"
            :per="20"
            :refreshCurrentPage="false"
          ></paginate>

          <paginate-links
            for="filteredPlaces"
            :limit="20"
            :show-step-links="true"
            :step-links="{
                          next: '>>',
                          prev: '<<'
                          }"
            :classes="{
              'ul': 'pagination',
              'li': 'page-item',
              'a': 'page-link',
            }"
          ></paginate-links>
          <br>
        </div>
      </b-card>
    </b-col>
    <Modal :showModal="showModal" :place="place" :type="type" @close="showModal = false" @onSaveNew="loadTable"
           @onSaveEdit="loadTable"/>
    <div v-if="showModal" class="modal-backdrop fade show"></div>
  </b-row>
</template>

<script>
  import api from '@/helpers/api'
  import Modal from "./Modal";

  export default {
    components: {Modal},
    data() {
      return {
        search: '',
        places: [],
        place: {},
        showModal: false,
        paginate: ['filteredPlaces'],
        type: 'Nueva'
      }
    },
    computed: {
      filteredPlaces(){
        return this.places.filter(place => {
          let condition = true
          let text = this.search.toLowerCase()
          if(text){
            condition = place.name.toLowerCase().includes(text) || place.zone.name.toLowerCase().includes(text)
          }
          return condition
        })
      }
    },
    mounted() {
      this.loadPlaces()
    },
    methods: {
      newPlace() {
        this.showModal = !this.showModal;
        this.place = {name: null, id: null, zone_id: null}
      },
      editPlace(place, type) {
        this.type = type
        this.place = JSON.parse(JSON.stringify(place));
        this.showModal = !this.showModal;
      },
      loadPlaces() {
        api.get('/places').then(response => {
          this.places = response.places
        })
      },
      loadTable() {
        this.loadPlaces();
      }
    }
  }
</script>
